"use client";
import { TasksBoard } from "@/components/TasksBoard";

export default function TasksPage() {
  return <TasksBoard />;
}
